// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".configuration-menu[data-v-b58aa1b4]{width:1000px}.objects-menu[data-v-b58aa1b4]{display:flex;gap:20px;padding:0 30px 15px 30px}", ""]);
// Exports
module.exports = exports;
